var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#241a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "242b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#242b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE0028",
    d: "M11 11.732c2.025 0 3.667-1.671 3.667-3.733S13.025 4.266 11 4.266 7.334 5.937 7.334 7.999 8.974 11.732 11 11.732"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "241a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagJp = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagJp);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYyMjlfNzE1NDgpIj4KPG1hc2sgaWQ9Im1hc2swXzYyMjlfNzE1NDgiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxNiI+CjxwYXRoIGQ9Ik0xOS45MDQ4IDBIMi4wOTUyNEMwLjkzODA3IDAgMCAwLjk1NTEyNiAwIDIuMTMzMzNWMTMuODY2N0MwIDE1LjA0NDkgMC45MzgwNyAxNiAyLjA5NTI0IDE2SDE5LjkwNDhDMjEuMDYxOSAxNiAyMiAxNS4wNDQ5IDIyIDEzLjg2NjdWMi4xMzMzM0MyMiAwLjk1NTEyNiAyMS4wNjE5IDAgMTkuOTA0OCAwWiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzYyMjlfNzE1NDgpIj4KPHBhdGggZD0iTTE5LjkwNDggMEgyLjA5NTI0QzAuOTM4MDcgMCAwIDAuOTU1MTI2IDAgMi4xMzMzM1YxMy44NjY3QzAgMTUuMDQ0OSAwLjkzODA3IDE2IDIuMDk1MjQgMTZIMTkuOTA0OEMyMS4wNjE5IDE2IDIyIDE1LjA0NDkgMjIgMTMuODY2N1YyLjEzMzMzQzIyIDAuOTU1MTI2IDIxLjA2MTkgMCAxOS45MDQ4IDBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTEuMDAwMiAxMS43MzIzQzEzLjAyNTIgMTEuNzMyMyAxNC42NjY4IDEwLjA2MDggMTQuNjY2OCA3Ljk5ODk2QzE0LjY2NjggNS45MzcxIDEzLjAyNTIgNC4yNjU2MiAxMS4wMDAyIDQuMjY1NjJDOC45NzUxMiA0LjI2NTYyIDcuMzMzNSA1LjkzNzEgNy4zMzM1IDcuOTk4OTZDNy4zMzM1IDEwLjA2MDggOC45NzUxMiAxMS43MzIzIDExLjAwMDIgMTEuNzMyM1oiIGZpbGw9IiNCRTAwMjgiLz4KPHBhdGggZD0iTTE5LjkwNDkgMC41MzUxNTZIMi4wOTUzNUMxLjIyNzQ4IDAuNTM1MTU2IDAuNTIzOTI2IDEuMjUxNSAwLjUyMzkyNiAyLjEzNTE2VjEzLjg2ODVDMC41MjM5MjYgMTQuNzUyMSAxLjIyNzQ4IDE1LjQ2ODUgMi4wOTUzNSAxNS40Njg1SDE5LjkwNDlDMjAuNzcyOCAxNS40Njg1IDIxLjQ3NjMgMTQuNzUyMSAyMS40NzYzIDEzLjg2ODVWMi4xMzUxNkMyMS40NzYzIDEuMjUxNSAyMC43NzI4IDAuNTM1MTU2IDE5LjkwNDkgMC41MzUxNTZaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF82MjI5XzcxNTQ4Ij4KPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";